import { IPlayerInMatch } from './player';

export enum MatchStatus {
    'uncommited' = 'uncommited',
    'commited' = 'commited',
    'rejected' = 'rejected',
}

// Есть у любого матча
interface DMatch {
    _id: string;
    createdAt: string;
    updatedAt: string;
    teamRadiant: IPlayerInMatch[];
    teamDire: IPlayerInMatch[];
}

// Заполняется юзером
interface FMatch {
    matchId: string;
    duration: number;
    radiant_win: boolean;
    radiantKills: number;
    direKills: number;
}

type CommitedMatch = DMatch & {
    status: MatchStatus.commited;
} & FMatch;

type UncommitedMatch = DMatch & {
    status: MatchStatus.uncommited;
} & Partial<FMatch>;

type RejectedMatch = DMatch & {
    status: MatchStatus.rejected;
} & Partial<FMatch>;

export type IMatch = CommitedMatch | UncommitedMatch | RejectedMatch;
